module.exports = __webpack_public_path__ + "static/media/th.8aa3ec14.svg";